export default "__VITE_ASSET__DsfhHHuQ__"